import * as Yup from 'yup';

const dictionaryValueSchema = Yup.object({
  Code: Yup.string().nullable().required('Code is required'),
});

export default dictionaryValueSchema;
